import { datadogRum } from '@datadog/browser-rum';
import { environment } from './environments/environment';

if (environment.dataDog) {
  datadogRum.init({
    applicationId: environment.dataDog.applicationId || '',
    clientToken: environment.dataDog.clientToken || '',
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: environment.dataDog.site || 'us5.datadoghq.com',
    service: environment.dataDog.service || 'dev-sgr5-new',
    env: environment.dataDog.env || 'dev',
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackBfcacheViews: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
}

import('./bootstrap').catch((err) => console.error(err));
